import Forum from "./src/Forum";

export default Forum